import { render } from "./DocumentView.vue?vue&type=template&id=9257c464&ts=true"
import script from "./DocumentView.vue?vue&type=script&lang=ts"
export * from "./DocumentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__